export const loadMessages = () => {
    const saved = localStorage.getItem('chat-messages');
    return saved ? JSON.parse(saved) : [];
};

export const saveMessages = (messages) => {
    localStorage.setItem('chat-messages', JSON.stringify(messages));
};

export const loadVisitorName = () => {
    return localStorage.getItem('visitor-name') || 'visitor';
};

export const saveVisitorName = (name) => {
    localStorage.setItem('visitor-name', name);
};

export const loadChuckMode = () => {
    return localStorage.getItem('chuck-mode') === 'true';
};

export const saveChuckMode = (isChuckMode) => {
    localStorage.setItem('chuck-mode', isChuckMode);
}; 